import { useDebugState } from './model';

export const debugEntity = {
  model: { useDebugState },
};
